// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__8gqn_","ranges":"BmiRanges_ranges__AHuao"};